import PropTypes from 'prop-types';
import { THREAD_LIST, THREAD_VIEW, KNOWLEDGE_BASE, KNOWLEDGE_BASE_ARTICLE } from '../constants/views';
export default PropTypes.oneOf([THREAD_LIST, THREAD_VIEW, KNOWLEDGE_BASE, KNOWLEDGE_BASE_ARTICLE]);